<template src="./RegistroHistorico.html"></template>
<style lang="scss" src="./RegistroHistorico.scss"></style>

<script>
import {Breadcrumb, BreadcrumbItem, Divider, Input, Switch} from 'element-ui'
import {requestSolicitudMixin} from "@/api/solicitudPH";
import {mapState} from "vuex"
import ScreenSizeMixin from "src/mixins/ScreenSizeMixin";
import {NotifyMixin} from "src/mixins/NotifyMixin";
import moment from 'moment-timezone'
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "RegistroHistorico",
  mixins: [
    requestSolicitudMixin,
    ScreenSizeMixin,
    NotifyMixin,
    RouterMixin
  ],
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Input.name]: Input,
    [Switch.name]: Switch,
    [Divider.name]: Divider,
  },
  computed: {
    ...mapState({
      user: state => state.user,
    })
  },
  data() {
    var validateConfirmacionEmail = (rule, value, callback) => {
      this.$log.debug('validateConfirmacionEmail')
      if (value === '') {
        callback(new Error('El correo electrónico es obligatorio'));
      } else if (value !== this.model.email) {
        callback(new Error('El correo electrónico no coincide'));
      } else {
        callback();
      }
    };
    const validateAcepta = (rule, value, callback) => {
      this.$log.debug('validateAcepta')
      if (value === '' || value === false) {
        callback(new Error('Debe aceptar la Declaración'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      errored: false,
      isAceptaValido: true,
      model: {
        rut: '',
        nombre: '',
        email: '',
        confirmacionEmail: '',
        acepta: false,
      },
      rules: {
        rut: [
          {
            length: 10,
            message: 'El RUT es obligatorio',
            trigger: 'blur'
          }
        ],
        nombre: [
          {
            min: 3,
            message: 'El nombre es obligatorio',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          }
        ],
        confirmacionEmail: [
          {
            required: true,
            message: 'El correo electrónico es obligatorio',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Ingrese un correo electrónico válido',
            trigger: ['blur', 'change']

          },
          {
            validator: validateConfirmacionEmail,
            trigger: 'blur'
          }
        ],
        acepta: [
          {
            required: true,
            message: 'Debe aceptar la Declaración',
            trigger: ['blur', 'change']
          },
          {
            validator: validateAcepta,
            trigger: ['blur', 'change']
          }
        ],
      },
    }
  },
  beforeMount() {
    this.model.rut = this.user.current.rut
    this.model.nombre = this.user.current.nombreCompleto
  },
  methods: {
    validate() {
      this.$refs['historicoForm']
        .validate((valid) => {
          if (valid) {
            this.$log.debug("enviando...")
            const loading = this.getLoading()

            this.enviarSolicitudCiudadano(loading)
              .then(response => {
                this.$log.debug('enviarSolicitudCiudadano', response)
                loading.close()
              })

          } else {
            this.$log.debug('error submit!!')
          }
        });
    },
    onAceptaChange() {
      this.isAceptaValido = true;
    },
    generarData() {
      let data = {};

      data.run = this.$store.state.user.current.cedula;
      data.email = this.model.email;

      data.today = new Date()
      data.tz = moment.tz.guess()

      return data;
    },
    enviarSolicitudCiudadano(loading) {
      let data = this.generarData();
      this.$log.debug('enviarSolicitudCiudadano', data)

      return this.crearSolicitud(data)
        .then(response => {
          this.$log.debug('crearSolicitud', response.data.statusCode)

          loading.close()
          if (response.data.statusCode === 200) {
            this.navigate({name: 'solicitudes-historicas'})
            return true
          } else {
            this.showError('Ocurrió un error inesperado al enviar la solicitud')
            return false
          }
        })
        .catch(err => {
          this.$log.fatal('enviarSolicitud', err, err.response, err.request)

          loading.close();
          this.showError('Ocurrió un error inesperado al enviar la solicitud')
          return false
        })
    }
  }
}

</script>


